import { useState, useEffect } from 'react';
import { useUserStore } from '../../store/models';

function isPhoneUnverified({ attributesLoaded, isFederated, phoneNumberVerified }) {
    if (!attributesLoaded) return false;
    if (isFederated) return false;
    // Cognito may return the value as boolean true or string 'true'
    return phoneNumberVerified !== true && phoneNumberVerified !== 'true';
}

function usePhoneVerificationStatus() {
    const userStore = useUserStore();
    const [showErrorIcon, setShowErrorIcon] = useState(false);

    useEffect(() => {
        const user = userStore?.user;
        const attributesLoaded = Boolean(user?.userAttributes);
        const isFederated = Boolean(user?.isFederated);
        const phoneNumberVerified = user?.userAttributes?.phone_number_verified;

        setShowErrorIcon(isPhoneUnverified({ attributesLoaded, isFederated, phoneNumberVerified }));
        // eslint-disable-next-line
    }, [userStore.observed.userAttributes]);

    return { showErrorIcon };
}

export default usePhoneVerificationStatus;
